// extracted by mini-css-extract-plugin
export default {"dialogContentContainer":"Modal_dialogContentContainer__LWG7Z","column":"Modal_column__K20cs","iconValidated":"Modal_iconValidated__XECv1","listItem":"Modal_listItem__089Oq"};